import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import isEmpty from 'lodash/isEmpty';
import classNames from 'classnames';

class CommunicateBox extends Component {

  state = {
    isStatic: false,
    manualClose: false,
    show: false
  };

  hideError = (e) => {
    e.preventDefault();
    if(this.props.hideCallback){
      this.props.hideCallback();
    }
    this.setState({ manualClose: true });
  }

  static getDerivedStateFromProps(props, state) {
    if (state.manualClose) {
      return { show: false, manualClose: false };
    }
    if (props.show !== undefined) {
      return { show: props.show, manualClose: false };
    }

    if (isEmpty(props.message)) {
      return { show: false };
    } else {
      return { show: true };
    }
  }

  render() {
    if (!this.state.show) {
      return null;
    }
    var icon = classNames(
      { 'exclamation-triangle': !this.props.isSuccess },
      { 'check': this.props.isSuccess },
    )
    return (
      <div className={classNames(
        'msg',
        { 'msg--error': !this.props.isSuccess },
        { 'msg--success': this.props.isSuccess },
        { 'msg--static': this.props.isStatic },
      )}
      >
        <p>
          <FontAwesomeIcon icon={['fas', icon]} />
          <span dangerouslySetInnerHTML={{ __html: this.props.message }} />
        </p>

        <button
          className="button button--text msg-close"
          aria-label="Close"
          onClick={this.hideError}
        >
          <FontAwesomeIcon icon={['fas', 'times']} />
        </button>
      </div>
    );
  }
}

export default CommunicateBox;
